import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import { publicRoutes } from './publicRoutes'
import { privateRoutes } from './privateRoutes'
import { validateRoutes } from './validateRoutes'

const routes: Array<RouteRecordRaw> = [
  ...publicRoutes,
  ...privateRoutes,
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

validateRoutes(router)

router.beforeEach((to) => {
  document.title = `${to.meta.title} - Full Life`
})

export default router
